import type { NextPage } from "next";
import Template from "@app/Template/Template";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const Home: NextPage = () => {
    const title = `${PROJECT_NAME} - недвижимость`;
    const description = "Likvi.com - недвижимость";
    const canonicalUrl = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.PROPERTY}`;

    return (
        <Template>
            <CustomHead
                title={title}
                description={description}
                robots={"index,follow"}
                canonical={canonicalUrl}
                openGraph={{
                    title: title,
                    description: description,
                    url: canonicalUrl,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        alt: title
                    }
                }}
            />
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    padding: "3em",
                    justifyContent: "center"
                }}
            >
                Property
            </div>
        </Template>
    );
};

export default Home;